import styled from 'styled-components';

export const PlainTextPopover = styled.div`
  min-width: 120px;
  max-width: 272px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
